
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoindorecabbooking() {



    const cardData =
    {
        keyword: ' Pune to Indore Cab Booking',
        heading: 'Prince Cabs: Pune to Indore Cab Booking',
        headingDescription: 'Prince Cabs offers reliable Pune to Indore Cab Booking, perfect for business trips, family travel, student journeys, and outstation tours. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride on the Pune–Indore route. With professional chauffeurs, transparent pricing, and on-time pickups, we make your long-distance journey smooth and hassle-free. Choose Prince Cabs’ trusted Pune to Indore cab booking service for affordability, convenience, and a stress-free travel experience.',

        top: 'Top Places to Visit in Indore with Prince Cabs',

"topPlaces": [
  {
    "title": "Rajwada Palace",
    "description": "Rajwada Palace is Indore’s most iconic landmark, built by the Holkars in the 18th century. The seven-story palace blends Maratha, Mughal, and French architectural styles. Its grand façade and intricately carved wooden balconies are captivating. The palace houses a courtyard, gardens, and temples. A light-and-sound show narrates Indore’s royal past. Rajwada reflects the city’s regal heritage and cultural pride."
  },
  {
    "title": "Lal Bagh Palace",
    "description": "Lal Bagh Palace is a magnificent residence of the Holkar rulers, showcasing European-inspired architecture. Spread across 28 acres, it features Italian marble floors, chandeliers, and Belgian stained glass. The palace reflects the lavish lifestyle of Indore’s royals. Visitors admire its grand Durbar Hall and sprawling lawns. The palace museum displays antiques and artifacts. It is Indore’s finest example of royal elegance."
  },
  {
    "title": "Sarafa Bazaar",
    "description": "Sarafa Bazaar is Indore’s most famous night food market, buzzing with street food lovers. After the jewelry shops close, food vendors take over the lanes. Dishes like poha-jalebi, pav bhaji, bhutte ka kees, and malpua are crowd favorites. The lively atmosphere continues until midnight. It is both a culinary and cultural experience. Sarafa is the heart of Indore’s street food culture."
  },
  {
    "title": "Chappan Dukan",
    "description": "Chappan Dukan, meaning ‘56 Shops,’ is a popular food street in Indore. It offers a variety of snacks, sweets, and fast food in a hygienic setup. Favorites include Indori poha, dahi bade, and chaat. The street comes alive in the evenings with families and youngsters. It reflects Indore’s love for food and flavors. Chappan Dukan is a must-visit for foodies exploring the city."
  },
  {
    "title": "Kanch Mandir",
    "description": "Kanch Mandir is a Jain temple in Indore, renowned for its exquisite glasswork interiors. Built by Seth Hukumchand, the temple features mirrors, stained glass, and mosaics depicting Jain traditions. The shimmering interiors create a divine aura. Devotees and tourists admire its spiritual and artistic significance. It is a unique blend of devotion and craftsmanship. Kanch Mandir is Indore’s shining jewel of faith."
  },
  {
    "title": "Bada Ganpati",
    "description": "Bada Ganpati, built in 1875, houses one of the largest idols of Lord Ganesha in the world. The 25-foot idol is made of limestone, jaggery, bricks, and sacred soil from holy places. Devotees believe it fulfills wishes and removes obstacles. The temple is a major spiritual landmark of Indore. Daily aartis attract large gatherings. It is a symbol of devotion and faith in the city."
  },
  {
    "title": "Central Museum (Indore Museum)",
    "description": "The Central Museum, also called Indore Museum, is a treasure trove of archaeological artifacts. It houses collections from the Holkar dynasty and pre-historic eras. Highlights include sculptures from the Parmar dynasty and ancient Jain art. The museum educates visitors about Malwa’s rich history and culture. Its galleries are well-curated for history enthusiasts. It is a must-visit for culture and heritage lovers."
  },
  {
    "title": "Annapurna Temple",
    "description": "Annapurna Temple is one of Indore’s most visited temples, dedicated to Goddess Annapurna, the goddess of food. Its architecture resembles the famous Meenakshi Temple of Madurai. The entrance is flanked by four life-sized elephants, making it visually striking. The temple also houses shrines for Lord Shiva, Hanuman, and Kalabhairava. Devotees visit to seek blessings of prosperity and nourishment. It is both a spiritual and cultural attraction."
  },
  {
    "title": "Patalpani Waterfall",
    "description": "Patalpani Waterfall, located 35 km from Indore, is a scenic natural escape. The waterfall cascades from a height of 300 feet into a deep gorge. Surrounded by hills and greenery, it is especially stunning during monsoon. Locals believe the water plunges into the mythical underworld (Patal), giving it its name. The spot is popular for picnics and treks. It is a refreshing getaway near Indore."
  },
  {
    "title": "Ralamandal Wildlife Sanctuary",
    "description": "Ralamandal Wildlife Sanctuary is Indore’s green retreat, spread over 5 sq. km. It is home to deer, leopards, wild hare, and a variety of birds. Trekking trails lead to a historic hunting lodge built by the Holkars. The sanctuary is ideal for nature walks and photography. Monsoon makes the forest lush and vibrant. It is perfect for nature lovers seeking tranquility near the city."
  },
  {
    "title": "Pipliyapala Regional Park",
    "description": "Pipliyapala Regional Park, also known as Atal Bihari Vajpayee Regional Park, is a well-developed leisure spot in Indore. It features boating facilities, musical fountains, gardens, and walking tracks. Families enjoy its children’s play zones and picnic areas. The park’s cleanliness and modern amenities attract daily visitors. Evening lighting adds to its charm. It is Indore’s favorite urban getaway."
  },
  {
    "title": "Khajrana Ganesh Temple",
    "description": "Khajrana Ganesh Temple is one of Indore’s most revered shrines, built by Rani Ahilyabai Holkar. The temple houses a magnificent idol of Lord Ganesha, worshipped by thousands daily. Devotees tie threads on the temple walls as a symbol of their wishes. The temple complex is spacious and well-maintained. Festivals like Ganesh Chaturthi are celebrated with grandeur here. It is a powerful center of faith in Indore."
  }
],

    "services": [
    {
      "name": "Pune to Bhopal Cab",
      "description": "Reliable and comfortable cab services from Pune to Bhopal with options including Innova Crysta, Dzire, and Etios. Enjoy a safe and hassle-free journey with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune to Bhopal Taxi",
      "description": "Affordable taxi options from Pune to Bhopal for both one-way and round trip travel. Perfect for business trips, family outings, or leisurely tours with clean and spacious cars."
    },
    {
      "name": "Pune to Bhopal Cab Service",
      "description": "Comprehensive cab service from Pune to Bhopal offering customized packages, punctual pickups, and 24/7 customer support to ensure a smooth travel experience."
    },
    {
      "name": "Cab from Pune to Bhopal",
      "description": "Book cabs from Pune to Bhopal with flexible scheduling, competitive pricing, and a variety of vehicle choices to suit your travel needs."
    },
    {
      "name": "Pune to Indore Cab",
      "description": "Comfortable and affordable cab service from Pune to Indore with professional chauffeurs and reliable vehicles like Innova Crysta and Dzire for a pleasant journey."
    },
    {
      "name": "Pune to Indore Taxi",
      "description": "Efficient taxi options for Pune to Indore travel with round trip and one-way packages, ensuring timely service and customer satisfaction."
    },
    {
      "name": "Pune to Indore Car Rental Price",
      "description": "Get the best car rental prices for Pune to Indore trips with competitive rates on popular vehicles such as Toyota Innova and Swift Dzire."
    },
    {
      "name": "Pune to Indore Cab Booking",
      "description": "Easy online cab booking from Pune to Indore with instant confirmation, 24/7 availability, and safe, comfortable rides."
    },
    {
      "name": "Pune to Indore Cab Service",
      "description": "Full-service cab options from Pune to Indore catering to business travelers, tourists, and families with reliable cars and professional drivers."
    },
    {
      "name": "Pune to Indore Dzire Taxi",
      "description": "Economical Dzire taxi service for Pune to Indore trips offering comfort, punctuality, and excellent customer service."
    },
    {
      "name": "Pune to Indore Innova Crysta",
      "description": "Luxury Innova Crysta taxi service from Pune to Indore providing spacious seating, premium comfort, and a smooth ride for group travelers."
    },
    {
      "name": "Pune to Indore Round Trip Cab",
      "description": "Convenient round trip cab packages from Pune to Indore with flexible scheduling and well-maintained vehicles for a hassle-free journey."
    },
    {
      "name": "Affordable Pune to Indore Taxi",
      "description": "Budget-friendly taxi services from Pune to Indore without compromising on comfort or safety, suitable for all traveler types."
    },
    {
      "name": "Luxury Pune to Indore Cab",
      "description": "Premium luxury cab options from Pune to Indore including Innova Crysta and other high-end vehicles for travelers seeking the best experience."
    }
  ],
  "tableData": [
    ["Pune to Bhopal Cab", "Pune to Bhopal Taxi"],
    ["Pune to Bhopal Cab Service", "Cab from Pune to Bhopal"],
    ["Pune to Indore Cab", "Pune to Indore Taxi"],
    ["Pune to Indore Car Rental Price", "Pune to Indore Cab Booking"],
    ["Pune to Indore Cab Service", "Pune to Indore Dzire Taxi"],
    ["Pune to Indore Innova Crysta", "Pune to Indore Round Trip Cab"],
    ["Affordable Pune to Indore Taxi", "Luxury Pune to Indore Cab"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Indore Cab Booking Service",
        "WhyChoosedescription": "Prince Cabs provides trustworthy and comfortable cab services from Pune to Indore, catering to business professionals, tourists, and families. Our service ensures a hassle-free, safe, and smooth journey across the approximately 500 km route, making your travel experience pleasant and stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes sedans and SUVs such as Swift Dzire, Innova, and more, all equipped with spacious seating, ample luggage capacity, and air conditioning. These vehicles are regularly maintained to ensure a comfortable and relaxing long-distance journey."
    },
    {
        "WhyChooseheading": "Professional Drivers with Route Expertise",
        "WhyChoosedescription": "Our experienced drivers are well-versed with the Pune to Indore highway routes, focusing on safe driving, timely breaks, and efficient navigation. They prioritize your safety and comfort throughout the trip."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Suit Your Travel Plans",
        "WhyChoosedescription": "Prince Cabs offers customizable packages including one-way trips, round trips with waiting time, and multi-day rentals. Booking is easy via phone, WhatsApp, or online, with instant confirmation and flexible cancellation policies."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our Pune to Indore cab services come with clear and competitive pricing that covers fuel, tolls, driver allowances, and taxes. Multiple secure payment methods are accepted, including UPI, credit/debit cards, net banking, and cash."
    },
    {
        "WhyChooseheading": "Sanitized and Well-Maintained Fleet for Your Safety",
        "WhyChoosedescription": "Each vehicle is thoroughly cleaned and sanitized before every trip to ensure a hygienic environment. Regular maintenance checks guarantee mechanical reliability, while safety features like seat belts and airbags ensure passenger protection."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Travel",
        "WhyChoosedescription": "Our dedicated customer support team is available round the clock to assist with bookings, itinerary changes, or any travel-related queries, ensuring a smooth and worry-free Pune to Indore cab experience."
    }
]





























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer cab service from Pune to Indore?',
        answer: 'Yes, Prince Cabs provides reliable and comfortable cab services from Pune to Indore for one-way and round-trip journeys.',
    },
    {
        question: 'What types of vehicles can I book for Pune to Indore cab service?',
        answer: 'We offer a variety of vehicles including Swift Dzire, Innova, and Tempo Traveller to accommodate solo travelers, families, and groups.',
    },
    {
        question: 'How long does the Pune to Indore trip take by cab?',
        answer: 'The journey typically takes around 11 to 13 hours, depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a round-trip cab for Pune to Indore?',
        answer: 'Absolutely! Prince Cabs provides flexible one-way and round-trip packages to suit your travel plans.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for long-distance travel?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and serviced to ensure your safety and comfort throughout the journey.',
    },
    {
        question: 'What are the approximate fares for Pune to Indore cab service?',
        answer: 'Fares vary depending on vehicle type, distance, and duration. Please contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book a Pune to Indore cab?',
        answer: 'Booking is easy via our website or by calling our customer support with your travel details for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Rohit Verma",
        position: "Business Traveler",
        text: "Booked a cab from Pune to Indore with Prince Cabs. The service was punctual and the ride was very comfortable. Highly recommend!",
        image: "/img/testimonial/testimonial-thumb-indore-1.png",
    },
    {
        name: "Ms. Sneha Gupta",
        position: "Family Traveler",
        text: "Our trip from Pune to Indore was hassle-free thanks to Prince Cabs. The cab was clean and the driver was courteous.",
        image: "/img/testimonial/testimonial-thumb-indore-2.png",
    },
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Indore Cab Booking",
  "description": "Affordable and reliable cab services from Pune to Indore, Bhopal, and nearby cities. Choose from Dzire, Innova Crysta, family cabs, and luxury taxi options with round trip packages available.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Bhopal Cab",
    "Pune to Bhopal Taxi",
    "Pune to Bhopal Cab Service",
    "Cab from Pune to Bhopal",
    "Pune to Indore Cab",
    "Pune to Indore Taxi",
    "Pune to Indore Car Rental Price",
    "Pune to Indore Cab Booking",
    "Pune to Indore Cab Service",
    "Pune to Indore Dzire Taxi",
    "Pune to Indore Innova Crysta",
    "Pune to Indore Round Trip Cab",
    "Affordable Pune to Indore Taxi",
    "Luxury Pune to Indore Cab"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};







    return (
        <div>
<Helmet>
  <title>Pune to Indore Cab Booking | Bhopal, Indore Taxi Service</title>
  <meta
    name="description"
    content="Affordable and reliable cab services from Pune to Indore, Bhopal, and nearby cities. Book Dzire, Innova Crysta, family cabs, and luxury taxi services with round trip packages."
  />
  <meta
    name="keywords"
    content="Pune to Bhopal Cab, Pune to Bhopal Taxi, Pune to Bhopal Cab Service, Cab from Pune to Bhopal, Pune to Indore Cab, Pune to Indore Taxi, Pune to Indore Car Rental Price, Pune to Indore Cab Booking, Pune to Indore Cab Service, Pune to Indore Dzire Taxi, Pune to Indore Innova Crysta, Pune to Indore Round Trip Cab, Affordable Pune to Indore Taxi, Luxury Pune to Indore Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/50.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoindorecabbooking ;